(function (angular) {
    'use strict';

    angular.module('app.benefit-info', []);
})(angular);
